import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ScheduleInternalTransactionDetail from "../../../containers/ScheduleInternalTransaction/ScheduleInternalTransactionDetail";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import ICONS from "../../../assets/Icons";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";

const dummyFn = () => {};

function ScheduleInternalTxnDetailPopup({
  closeScheduleInternalTxnModal,
  schedule_internaltxn_id,
  detailSelected,
  type,
  typeMulti,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="Internal schedule details"
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        headersubtext=""
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeScheduleInternalTxnModal();
          navigate(
            `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${schedule_internaltxn_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewdisabledBgColor="var(--text-disabled)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        closeiconbtnType="button"
        closeiconhandleFunction={closeScheduleInternalTxnModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <div className="w-full h-full overflow-y-auto overflow-x-hidden">
          <ScheduleInternalTransactionDetail
            txn_id={schedule_internaltxn_id}
            isPopup={true}
            closeScheduleInternalTxnModal={closeScheduleInternalTxnModal}
            detailSelected={detailSelected ?? dummyFn}
            type={type}
            typeMulti={typeMulti}
          />
        </div>
      </LargePopupRedirect>
    </div>
  );
}

export default ScheduleInternalTxnDetailPopup;
